import React from 'react';
import PropTypes from 'prop-types';
import { useConfigService } from '@thd-nucleus/experience-context';
import { isFunction } from '../../../components/helper/utils';
import { InStockIcon } from '../../helpers/icon-utils';
import { PICKUP_TEMPLATES } from '../../templates/templatesConstant';
import {
  formatSellableQuantity
} from '../../helpers/pod-fulfillment-utils';
import { PodMessage } from '../PodMessage';

export const BOSS = ({
  displayQuantity = 0,
  customRender = null,
  isNewFulfillmentPodMessagingEnabled = false,
  isNarrowPod = false
}) => {

  const enablePLPFasterDeliveryOption = !!useConfigService('fs:enablePLPFasterDeliveryOption');
  let messagingSuccess = 'Free ';
  let messagingPrimary = 'Ship to Store';
  let messagingFree = '';
  let messagingBOSS = '';

  if (displayQuantity > 0) {
    const formattedQty = formatSellableQuantity(displayQuantity);
    messagingSuccess = `${formattedQty} `;
    messagingPrimary = `eligible${!isNewFulfillmentPodMessagingEnabled ? ' for' : ''}`;
    messagingFree = ' Free ';
    messagingBOSS = 'Ship to Store';
  }

  if (isFunction(customRender)) {
    return customRender(
      {
        pickUpTemplate: PICKUP_TEMPLATES.BOSS,
        icon: InStockIcon,
        values: { messagingSuccess, messagingPrimary, displayQuantity }
      });
  }

  // render current prod messaging
  const renderOldMessaging = () => (
    <>
      <span className="sui-text-success">{messagingSuccess}</span>
      <span className="sui-text-success">
        <span className={messagingBOSS === '' ? '' : 'sui-text-primary'}>{messagingPrimary}</span>
        {messagingFree}
        {messagingBOSS}
      </span>
    </>
  );

  // B2B user display: Free Ship to Store | 2 eligible
  // B2C user display: Free Ship to Store
  const renderPlpSpeedNewMessaging = () => (
    <>
      {(messagingFree && messagingBOSS) && (
        <>
          <span className="sui-text-success">{`${messagingFree}${messagingBOSS} `}</span>
          <span className="sui-text-primary">{'| '}</span>
        </>
      )}
      <span className="sui-text-success">{messagingSuccess}</span>
      <span className={`${(messagingFree && messagingBOSS) ? 'sui-text-primary' : 'sui-text-success'}`}>
        {messagingPrimary}
      </span>
    </>
  );

  // Render new plp faster messaging
  // Ex: Free | 6 eligible or Pickup
  const renderPlpFasterDeliveryOption = () => (
    <span>
      <span className="sui-text-success">Free</span>
      {' | '}
      {displayQuantity > 0 && <span className="sui-text-success">{`${messagingSuccess}`}</span>}
      {displayQuantity > 0 ? 'eligible' : 'Pickup'}
    </span>
  );

  let bossMessaging = '';
  if (enablePLPFasterDeliveryOption) {
    bossMessaging = renderPlpFasterDeliveryOption();
  } else if (isNewFulfillmentPodMessagingEnabled) {
    bossMessaging = renderPlpSpeedNewMessaging();
  } else {
    bossMessaging = renderOldMessaging();
  }

  return (
    <PodMessage
      messageIcon={InStockIcon}
      messageType={enablePLPFasterDeliveryOption ? 'Ship to Store' : 'Pickup'}
      isNarrowPod={isNarrowPod}
    >
      {bossMessaging}
    </PodMessage>
  );
};

BOSS.propTypes = {
  displayQuantity: PropTypes.number,
  customRender: PropTypes.func,
  isNewFulfillmentPodMessagingEnabled: PropTypes.bool,
  isNarrowPod: PropTypes.bool
};